export const tooltipTestId = 'coming-soon-test-id';
export const tooltipChildTestId = 'tooltip-child-test-id';
export const tooltipContent = 'Coming Soon';
